var _SentryManager_config, _SentryManager_useSentry;
import { __awaiter, __classPrivateFieldGet, __classPrivateFieldSet, __decorate } from "tslib";
import { singleton } from 'tsyringe';
import { init, captureException } from '@sentry/browser';
let SentryManager = class SentryManager {
    constructor() {
        _SentryManager_config.set(this, void 0);
        _SentryManager_useSentry.set(this, void 0);
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.registerSentry(config);
        });
    }
    registerSentry(config) {
        try {
            if (config.errorReporting.dsn) {
                init({ dsn: config.errorReporting.dsn });
                __classPrivateFieldSet(this, _SentryManager_useSentry, true, "f");
            }
        }
        catch (error) {
            console.warn('Unable to start sentry');
        }
    }
    captureException(error) {
        try {
            if (__classPrivateFieldGet(this, _SentryManager_useSentry, "f")) {
                captureException(error);
            }
        }
        catch (err) {
            console.log(err);
        }
    }
};
_SentryManager_config = new WeakMap(), _SentryManager_useSentry = new WeakMap();
SentryManager = __decorate([
    singleton()
], SentryManager);
export { SentryManager };
